module.exports = __webpack_public_path__ + "img/底图@2x.d2189ae3.png";